import { MrInputSink } from '@mrhenry/wp--mr-interactive';

customElements.define( 'mr-input-sink', MrInputSink );
